import { LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "~/components/ui/accordion";
import { getLocale } from "~/lib/i18n.server";
import { getMetaData } from "~/lib/utils";

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const { t } = useTranslation();
  return getMetaData(data, {
    title: t("FAQ - Domande frequenti"),
    description: t(
      "Hai domande? Consulta le nostre FAQ per trovare le risposte che cerchi. Informazioni su prenotazioni, orari, trattamenti e molto altro a portata di click."
    ),
  });
};
export async function loader({ context, request }: LoaderFunctionArgs) {
  try {
    const pageSlug = "faq";

    const locale = await getLocale(request);
    const lang = locale;
    const res = await fetch(
      `${context.cloudflare.env.WP_API_HOST}/wp-json/wp/v2/pages?slug=${pageSlug}&lang=${lang}`
    );
    const pages: any = await res.json();
    if (!res.ok) {
      throw new Error(`Failed to fetch: ${res.statusText}`);
    }
    if (pages && pages.length > 0) {
      return {
        page: pages[0],
        seo: pages[0]?.yoast_head_json,
        lang,
      };
    } else {
      return {
        error: "No pages found for the given slug.",
        page: {},
      };
    }
  } catch (err) {
    return {
      err: err,
      page: {},
    };
  }
}

export default function FAQ() {
  const loaderData = useLoaderData<typeof loader>();

  return (
    <div
      className={`
        relative
      `}
    >
      <main className="flex flex-col">
        {loaderData.page.acf?.hero && (
          <section
            className="bg-cover bg-center bg-no-repeat "
            style={{
              backgroundImage: `url('/cms-asset/${loaderData.page.acf?.hero.image.id}')`,
            }}
          >
            <div className="bg-black bg-opacity-40 py-32">
              <div className="flex flex-col max-w-4xl mx-auto items-center justify-center">
                <h1 className="text-4xl lg:text-5xl text-white font-tenor-sans uppercase">
                  {loaderData.page.acf?.hero.title}
                </h1>
                <hr className="block w-16 h-[2px] bg-white mt-2" />
                <p className="text-white text-lg mt-4">
                  {loaderData.page.acf?.hero.description}
                </p>
              </div>
            </div>
          </section>
        )}

        {loaderData.page && loaderData.page.acf?.list && (
          <section className="w-full py-12 grid grid-cols-1 gap-8 px-4">
            {loaderData.page.acf?.list.map(
              (section: any, listIndex: number) => {
                return (
                  <div
                    key={listIndex}
                    className="flex flex-col max-w-4xl w-full mx-auto"
                  >
                    <h4 className="font-tenor-sans text-secondary text-2xl border-b-[1px] border-b-secondary uppercase pb-1">
                      {section.title}
                    </h4>
                    <Accordion className="w-full" type="single" collapsible>
                      {section.items.map((item: any, index: number) => {
                        return (
                          <AccordionItem
                            key={index}
                            className="w-full border-b-secondary"
                            value={"section-" + listIndex + "-" + index}
                          >
                            <AccordionTrigger className="w-full text-lg font-semibold">
                              {item.title}
                            </AccordionTrigger>
                            <AccordionContent className="w-full">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.description,
                                }}
                              />
                            </AccordionContent>
                          </AccordionItem>
                        );
                      })}
                    </Accordion>
                  </div>
                );
              }
            )}
          </section>
        )}
      </main>
    </div>
  );
}
